/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { useErrorHandler } from 'react-error-boundary';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/ja';

// import receptionRegister from '../../api/reception/receptionRegister';
import MoveTop from '../../CommonParts';
import changeConfirmation from '../../api/reserveChange/changeConfirmation';
import configMastaApi from '../../api/masta/configMasta';
import { useDidMount } from '../../customHooks';
import TopicPath from '../../components/TopicPath';
import { ReserveHeader } from '../../components/Header';
import { Footer } from '../../components/Footer';
import operationalLogs from '../../api/log/operationalLogs';

import {
  RSV_FLAG_PHONE,
  INPUT_TYPE_BIRTHDAY,
  INPUT_EXP_FLAG,
  INPUT_DATE_FLAG,
  CANCEL_CHANGE_ANNOUNCE,
  DEFAULT_HOME_USE_LABEL,
} from '../../constants';
import { dispTellStartPeople } from '../../utils';

dayjs.extend(utc);
dayjs.extend(localeData);
dayjs.extend(weekday);
dayjs.locale('ja');

const ChangeConfirmation = function () {
  const navigate = useNavigate();
  const handleError = useErrorHandler();

  const reserveChange = useSelector((state) => state.reserveChange);

  const rsvFlag = useSelector((state) => state.reserveChange.rsvFlag);
  const businessChangeMode = useSelector((state) => state.reserveChange.businessChangeMode);
  const businessChanged = useSelector((state) => state.reserveChange.businessChanged);

  const { url: chUrl = '', rsvSetId = '', sendType = '', useHome, place = '' } = reserveChange;
  const {
    name: placeName = '',
    address: placeAddress = '',
    subAddress: placeSubAddress = '',
    tel: placeTel = '',
  } = place;

  const rsvConfig = useSelector((state) => state.rsvConfig);
  const { topicPath = [], locationSetting = {} } = rsvConfig;
  const homeUseLabel = locationSetting?.item_label?.home_use || DEFAULT_HOME_USE_LABEL;

  const location = useLocation();
  const newTimearea = location.state.newTimearea ?? '';
  const newDate = location.state.date ?? '';
  const newDayOfWeek = location.state.newDayOfWeek ?? '';
  // const rsvFlameId = location.state.rsvFlameId ?? 0;
  const newRsvDateWithTime = location.state.newRsvDateWithTime ?? '';
  const sameDay = location.state.sameDay ?? false;
  const sameTime = location.state.sameTime ?? false;
  // ChangeForm で入力したフォーム回答・フラグ（Redux から取得）
  const fromChangeForm = useSelector((state) => state.reserveChange.fromChangeForm);
  const answerListFromForm = useSelector((state) => state.reserveChange.answerList);
  const numOfAttendeesFromForm = useSelector((state) => state.reserveChange.numOfAttendees);
  const noteFromForm = useSelector((state) => state.reserveChange.note);
  const reduxBaseName = useSelector((state) => state.reserveChange.baseName);

  // const [over, setOver] = useState(false);
  const [fromMailAddress, setFromMailAddress] = useState('xxx@xxxxxx.ne.jp');
  const [pageName, setPageName] = useState('');
  const [backUrl, setBackUrl] = useState('');
  const [tellStartPeople, setTellStartPeople] = useState(1);

  // 予約設定マスタの検索
  const getReserveSetting = async () => {
    const { rsvSetId } = reserveChange;
    const result = await changeConfirmation.searchReserveSetting(rsvSetId);
    const { tellStart = 0 } = result;
    setTellStartPeople(tellStart);
  };

  // 自分の予約数と１人ができる予約の最大数の比較
  // const getReserveCount = async () => {
  //   const { mailAddress, sendType, telNum } = reserve;
  //   const { count } = await changeConfirmation
  //     .searchReserveCount(rsvSetId, sendType, mailAddress, telNum)
  //     .catch((err) => {
  //       window.alert('予約受付情報の取得に失敗しました。');
  //       handleError(err);
  //     });

  //   return count;
  // };

  // パンくずリスト設定から、ページ名・前の画面のURLをstateに設定(予約変更)
  const getBackUrlAndPageName = (topicPathConf) => {
    const locationPath = window.location.pathname;
    const tmpPath1 = locationPath.replace('/reserve/', '');
    const tmpPath2 = tmpPath1.replace('/test', '');
    const currentPath = tmpPath2.replace('/demo', '');

    let backUrl = '';
    let scnName = '';
    for (let i = 0; i < topicPathConf.length; i += 1) {
      const { url = '', scnName: tmpScnName = '' } = topicPathConf[i];
      if (currentPath === url) {
        // 「前に戻る」先のURL取得
        const { url: tmpBackUrl = '' } = topicPathConf[i - 1];
        if (tmpBackUrl === 'change/:url') {
          backUrl = `change/${chUrl}`;
        } else if (businessChangeMode === 1) {
          // 用件変更モード: 用件を変更したかどうかで戻り先を分岐
          if (businessChanged === true) {
            // 用件を変更した場合 → 予約者情報の変更画面に戻る
            backUrl = tmpBackUrl; // topicPath の前の画面 = 'change/userinfo'
          } else {
            // 用件を変更しなかった場合 → 利用時間の変更画面に戻る（予約者情報をスキップ）
            backUrl = 'change/time';
          }
        } else if (businessChangeMode === 2 || businessChangeMode === 3) {
          backUrl = tmpBackUrl;
        }

        // pageNameを取得
        scnName = tmpScnName;

        break;
      }
    }

    setPageName(scnName);
    setBackUrl(backUrl);
  };

  // 初期処理
  const init = async () => {
    // ページ名/戻り先URLの取得
    getBackUrlAndPageName(topicPath);

    // displayRecItems();

    const fromMailConf = await configMastaApi.findByConfCd('rsv_from_mailaddress').catch((err) => {
      window.alert('予約受付設定の取得に失敗しました。');
      handleError(err);
    });
    const { value: fromMail = '' } = fromMailConf;

    setFromMailAddress(fromMail);
  };

  useDidMount(() => {
    init();
    getReserveSetting();
  });

  // 予約データの更新
  const changeReserve = async () => {
    const {
      // rsvDateWithTime = '',
      // timearea = '',
      business = {},
      recItem = [],
      lgCd,
      receptionId,
      rsvFlag,
      userName,
      address,
      birthday,
      telNum,
      mailAddress,
      formSetId,
    } = reserveChange;

    // モード1かつ用件を変更したとき個人情報を送信する（T_CITIZEN.recept_info の更新に使用）
    // 用件を変更しなかった場合はフォームをスキップしているため空文字になっており、送信しない
    const personalInfo =
      businessChangeMode === 1 && businessChanged === true
        ? {
          userName: userName !== '' ? userName : reduxBaseName,
          address,
          birthday,
          telNum,
          mailAddress,
          sendType: reserveChange.sendType,
        }
        : null;

    try {
      const { receptionId: changedRecId = '', msg = '' } = await changeConfirmation.updateReception(
        lgCd,
        receptionId,
        business,
        recItem,
        {
          rsvDate: newRsvDateWithTime,
          timearea: newTimearea,
        },
        sameDay,
        sameTime,
        '', // userCd 予約の場合は空でよい
        rsvSetId,
        place,
        useHome,
        rsvFlag,
        businessChangeMode,
        businessChanged,
        answerListFromForm,
        numOfAttendeesFromForm,
        noteFromForm,
        personalInfo,
        formSetId
      );
      if (msg) {
        window.alert(msg);
        return;
      }
      // 処理完了後はTopに戻したいためセッションストレージから削除
      sessionStorage.removeItem('changeUrl');
      navigate('/change/cmplt', {
        state: {
          receptionId: changedRecId,
          rsvSetId,
          lgCd: reserveChange.lgCd,
          businessChanged,
        },
      });

      // 処理記録
      operationalLogs.createOprLogs('', '', '040003001', 'RsvOnlyWithoutUser', changedRecId); // 更新後の受付IDを入れている
    } catch (err) {
      window.alert('予約登録に失敗しました。');
    }
  };

  // 選択した用件を表示用に成形
  const displayRecItems = () => {
    const result = [];
    const recItems = reserveChange.recItem;
    const { business } = reserveChange;

    const businessKeys = Object.keys(business);
    for (let i = 0; i < businessKeys.length; i += 1) {
      const nowBusinessKey = businessKeys[i];
      const { businessName = '' } = business[nowBusinessKey];
      const targetRecItems = recItems.filter(
        (item) => parseInt(item.businessId, 10) === parseInt(nowBusinessKey, 10)
      );

      const recItemKeys = Object.keys(targetRecItems);
      if (recItemKeys.length > 0) {
        result.push(<h3>{businessName}</h3>);
      }

      const tmpItems = {};
      for (let j = 0; j < recItemKeys.length; j += 1) {
        const nowRecItem = recItemKeys[j];
        const { groupId, groupName, recItemId, recItemName } = targetRecItems[nowRecItem];
        if (!tmpItems[groupId]) {
          tmpItems[groupId] = { groupName, items: [] };
        }

        tmpItems[groupId].items[recItemId] = <li style={{ marginLeft: '42px' }}>{recItemName}</li>;
      }

      const items = [];
      Object.keys(tmpItems).map((e) => {
        items.push(<strong style={{ marginLeft: '18px' }}>■{tmpItems[e].groupName}</strong>);
        items.push(<ul key={`item${i}`}>{tmpItems[e].items}</ul>);
      });

      result.push(items);
    }

    return result;
  };

  const onClickBack = () => {
    // ChangeForm を経由してきた場合、または showFullForm（用件変更モード1かつ用件変更あり）の場合は
    // ChangeForm に正しい location.state を渡して戻る
    if (fromChangeForm || (businessChangeMode === 1 && businessChanged === true)) {
      navigate('/change/userinfo', { state: location.state });
    } else {
      navigate(`/${backUrl}`, { state: { date: newDate, dayOfWeek: newDayOfWeek, sameDay } });
    }
  };

  /**
   * ChangeForm で入力したフォーム回答を確認テーブルに表示する
   * 個人情報フィールド・説明・外部URLはスキップ
   */
  const displayFormAnswers = () => {
    if (!fromChangeForm || !answerListFromForm || answerListFromForm.length === 0) return null;

    // 2の時は個人情報を入れない。
    let answerList = [];
    if (businessChangeMode === 2) {
      const newArray = [...answerListFromForm];
      const slicedArray = newArray.slice(4);
      answerList = [...slicedArray];
    } else if (businessChangeMode === 1) {
      answerList = [...answerListFromForm];
    }

    const details = [];
    if ((businessChangeMode === 1 && businessChanged === true) || businessChangeMode === 2) {
      for (let i = 0; i < answerList.length; i += 1) {
        const { question = '', answer = [], inputType = 1 } = answerList[i];
        if (inputType !== INPUT_EXP_FLAG && answer[0] !== '' && answer.length !== 0) {
          details.push(
            <dl key={`makeDetail_${i}`}>
              <dt className="textCnfCmp characterDown">{question}</dt>
              <dd className="textCnfCmp characterDown">
                {inputType === INPUT_DATE_FLAG || inputType === INPUT_TYPE_BIRTHDAY
                  ? dayjs(answer[0]).format('YYYY[/]MM[/]DD')
                  : answer.join(',')}
              </dd>
            </dl>
          );
        }
      }
    }

    return details;
  };

  // sendType は変更時は常に変更不可のため、Redux の sendType（元の予約の値）を使う
  const effectiveSendType = sendType;

  /**
   *
   * @returns メール、SMS、メール＆SMSの場合の画面文言分岐
   */
  const sendMailOrSms = () => {
    if (effectiveSendType === 1) {
      return (
        <>
          <dl>
            <dt>メール</dt>
            <dd className="sendConfirm">{reserveChange.mailAddress}</dd>
          </dl>
          <div className="sendConfirm ft_12px">
            予約変更が完了しますと、完了メールが送信されます。
            <div className="characterDown">
              {fromMailAddress}からのメール受信が可能か、再度確認してください。
            </div>
          </div>
        </>
      );
    }
    if (effectiveSendType === 2) {
      return (
        <>
          <dl>
            <dt>SMS</dt>
            <dd className="sendConfirm">送信する</dd>
          </dl>
          <dl>
            <dt>電話番号（SMS送信用）</dt>
            <dd>{reserveChange.telNum}</dd>
          </dl>
          <div className="sendConfirm ft_12px">
            予約変更が完了しますと、SMSが送信されます。
            <div className="characterDown">
              携帯電話でSMSの受信許可の設定を、再度確認してください。
            </div>
          </div>
        </>
      );
    }
    if (effectiveSendType === 3) {
      return (
        <>
          <dl>
            <dt>SMS</dt>
            <dd className="sendConfirm">送信する</dd>
          </dl>
          <dl>
            <dt>電話番号（SMS送信用）</dt>
            <dd>{reserveChange.telNum}</dd>
          </dl>
          <dl>
            <dt>メール</dt>
            <dd className="sendConfirm">{reserveChange.mailAddress}</dd>
          </dl>
          <div className="sendConfirm ft_12px">
            予約変更が完了しますと、メールとSMSが送信されます。
            <div className="characterDown">
              {fromMailAddress}からのメール受信が可能か、再度確認してください。
              <br />
              携帯電話でSMSの受信許可の設定を、再度確認してください。
            </div>
          </div>
        </>
      );
    }
  };

  return (
    <>
      <ReserveHeader servCd="reserve" lgCd={reserveChange.lgCd} />
      <div id="container">
        <TopicPath />
        <main>
          <article>
            <div id="contents">
              <MoveTop lgCd={reserveChange.lgCd} />
              <div className="inner">
                <h2>{pageName}</h2>
                <p className="txtCenter">予約内容を確認してください。</p>
                <table className="tbl_confirmation noBorder">
                  <tbody>
                    <tr>
                      <th>利用場所</th>
                      {useHome ? (
                        <td>{homeUseLabel}</td>
                      ) : (
                        <td>
                          {placeName}
                          {placeName && placeAddress ? <br /> : null}
                          {`${placeAddress} ${placeSubAddress}`}
                          {placeAddress && placeTel ? <br /> : null}
                          {placeTel ? `TEL: ${placeTel}` : ''}
                          <br />
                          {rsvFlag === RSV_FLAG_PHONE ? dispTellStartPeople(tellStartPeople) : null}
                        </td>
                      )}
                    </tr>
                    <tr>
                      <th>利用日時</th>
                      <td>{`${dayjs(newRsvDateWithTime).format('YYYY[年]M[月]D[日]')}(${reserveChange.rsvDayOfWeek
                        })${dayjs(newRsvDateWithTime).format('H[時]mm[分]')}`}</td>
                    </tr>
                    {reserveChange.recItem.length > 0 ? (
                      <tr>
                        <th>用件</th>
                        <td>{displayRecItems()}</td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
                {/* ChangeForm で入力したフォーム回答 */}
                {(businessChangeMode === 1 && businessChanged === true) ||
                  businessChangeMode === 2 ? (
                  <p className="txtCenter">
                    <strong>変更内容</strong>
                  </p>
                ) : null}
                <div className="customInputData textDown">
                  {displayFormAnswers()}
                  {/* ChangeForm で入力した同席者数 */}
                  {((businessChanged === true && businessChangeMode === 1) ||
                    businessChangeMode === 2) &&
                    numOfAttendeesFromForm !== null &&
                    numOfAttendeesFromForm !== 0 ? (
                    <dl>
                      <dt>同席者数</dt>
                      <dd>{numOfAttendeesFromForm}人</dd>
                    </dl>
                  ) : null}
                  {((businessChangeMode === 1 && businessChanged === true) ||
                    businessChangeMode === 2) &&
                    noteFromForm !== '' ? (
                    <dl>
                      <dt>備考</dt>
                      <dd className="sendConfirm characterDown">{noteFromForm}</dd>
                    </dl>
                  ) : null}
                  {businessChangeMode === 1 && businessChanged === true ? sendMailOrSms() : null}
                </div>
                <ul id="navi" className="row jcSB">
                  <li className="col2">
                    <a
                      role="button"
                      // href="javascript:void(0);"
                      // onClick={() => navigate(-1)}
                      onClick={() => onClickBack()}
                      className="btn btBack"
                      tabIndex={0}
                    >
                      前に戻る
                    </a>
                  </li>
                  <li className="col2 mr0 row jcFE">
                    <a
                      role="button"
                      // href="javascript:void(0);"
                      className="btn btNext"
                      onClick={changeReserve}
                      tabIndex={0}
                    >
                      予約を確定する
                    </a>
                  </li>
                </ul>
              </div>
              <div className="cancelAnnounce">{CANCEL_CHANGE_ANNOUNCE}</div>
            </div>
          </article>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default ChangeConfirmation;
